module.exports = __webpack_public_path__ + "static/media/colors.0d482ecd.png";